/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type CloneToolsetSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CloneToolsetSecurityOption2 = {
  apikeyHeaderAuthorization: string;
  projectSlugHeaderGramProject: string;
};

export type CloneToolsetSecurity = {
  option1?: CloneToolsetSecurityOption1 | undefined;
  option2?: CloneToolsetSecurityOption2 | undefined;
};

export type CloneToolsetRequest = {
  /**
   * The slug of the toolset to clone
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type CloneToolsetSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CloneToolsetSecurityOption1$outboundSchema: z.ZodMiniType<
  CloneToolsetSecurityOption1$Outbound,
  CloneToolsetSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function cloneToolsetSecurityOption1ToJSON(
  cloneToolsetSecurityOption1: CloneToolsetSecurityOption1,
): string {
  return JSON.stringify(
    CloneToolsetSecurityOption1$outboundSchema.parse(
      cloneToolsetSecurityOption1,
    ),
  );
}

/** @internal */
export type CloneToolsetSecurityOption2$Outbound = {
  apikey_header_Authorization: string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CloneToolsetSecurityOption2$outboundSchema: z.ZodMiniType<
  CloneToolsetSecurityOption2$Outbound,
  CloneToolsetSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderAuthorization: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderAuthorization: "apikey_header_Authorization",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function cloneToolsetSecurityOption2ToJSON(
  cloneToolsetSecurityOption2: CloneToolsetSecurityOption2,
): string {
  return JSON.stringify(
    CloneToolsetSecurityOption2$outboundSchema.parse(
      cloneToolsetSecurityOption2,
    ),
  );
}

/** @internal */
export type CloneToolsetSecurity$Outbound = {
  Option1?: CloneToolsetSecurityOption1$Outbound | undefined;
  Option2?: CloneToolsetSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CloneToolsetSecurity$outboundSchema: z.ZodMiniType<
  CloneToolsetSecurity$Outbound,
  CloneToolsetSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CloneToolsetSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CloneToolsetSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function cloneToolsetSecurityToJSON(
  cloneToolsetSecurity: CloneToolsetSecurity,
): string {
  return JSON.stringify(
    CloneToolsetSecurity$outboundSchema.parse(cloneToolsetSecurity),
  );
}

/** @internal */
export type CloneToolsetRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const CloneToolsetRequest$outboundSchema: z.ZodMiniType<
  CloneToolsetRequest$Outbound,
  CloneToolsetRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function cloneToolsetRequestToJSON(
  cloneToolsetRequest: CloneToolsetRequest,
): string {
  return JSON.stringify(
    CloneToolsetRequest$outboundSchema.parse(cloneToolsetRequest),
  );
}
